
import { Video } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from 'react-i18next';

interface SessionTypeFilterProps {
  sessionType: string | string[];
  onSessionTypeChange: (type: string | string[]) => void;
}

const SessionTypeFilter = ({ sessionType, onSessionTypeChange }: SessionTypeFilterProps) => {
  const { t } = useTranslation('practitioners');

  // Convert to array for consistent handling
  const selectedTypes = Array.isArray(sessionType) ? sessionType : 
    sessionType === 'all' ? ['virtual', 'in_person'] : [sessionType];

  const handleTypeToggle = (type: string) => {
    let newTypes: string[];
    
    if (selectedTypes.includes(type)) {
      // Uncheck - remove from array
      newTypes = selectedTypes.filter(t => t !== type);
      // If none selected, select the other one
      if (newTypes.length === 0) {
        newTypes = type === 'virtual' ? ['in_person'] : ['virtual'];
      }
    } else {
      // Check - add to array
      newTypes = [...selectedTypes, type];
    }
    
    onSessionTypeChange(newTypes);
  };

  return (
    <div>
      <h3 className="text-sm font-semibold mb-3 flex items-center">
        <Video className="mr-2 h-4 w-4 text-amber-600" /> {t('sessionType')}
      </h3>
      <div className="flex flex-wrap gap-4">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="virtual"
            checked={selectedTypes.includes('virtual')}
            onCheckedChange={() => handleTypeToggle('virtual')}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="virtual" className="text-sm font-medium cursor-pointer">
            {t('virtual')}
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="in_person"
            checked={selectedTypes.includes('in_person')}
            onCheckedChange={() => handleTypeToggle('in_person')}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="in_person" className="text-sm font-medium cursor-pointer">
            {t('inPerson')}
          </label>
        </div>
      </div>
    </div>
  );
};

export default SessionTypeFilter;
